import * as React from 'react';
import * as style from './Basic.css';
import { ArticleHeading1, InlineText1 } from '@cian/ui-kit';
import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import { SalesLeader } from '../SalesLeader';
import { Link } from '../../../Link';
import { trackGoToDeveloperSite } from '../../../../analytics/trackGoToDeveloperSiteButtonClick';

export interface IBasicProps {
  /** Название для отображения **/
  name: string;
  /** Информация о сдаче ЖК **/
  specialStatusDisplay: string;
  /** ЖК находится в списке лидеров продаж **/
  isSalesLeader: boolean;
  /** Ссылка на сайт ЖК */
  website?: string | null;
}

export const Basic: React.FC<IBasicProps> = props => {
  const { name, specialStatusDisplay, isSalesLeader, website } = props;

  const salesLeaderIcon = isSalesLeader ? <SalesLeader /> : null;

  return (
    <div className={style['basic']}>
      <div className={style['basic-content']}>
        <div className={style['basic-top']}>
          <ArticleHeading1 as={'h1'} color={'theme-black'}>
            {name} {salesLeaderIcon}
          </ArticleHeading1>
          <div className={style['basic-section']}>
            {specialStatusDisplay && (
              <div className={style['basic-special-status']}>
                <InlineText1 color={'black_60'}>{specialStatusDisplay}</InlineText1>
              </div>
            )}
            {website && (
              <Link
                target="blank"
                linkStyle={style['developerSiteLink']}
                rel="nofollow noopener"
                url={website}
                onClick={() => trackGoToDeveloperSite(website)}
              >
                <InlineText1 color="text-main-default">Перейти на сайт ЖК</InlineText1>
                <div className={style['developerSiteLink-icon']}>
                  <IconActionArrowUpRight16 color="icon-main-default" />
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
